import appEnv from 'app-env';
import { createAuthManager } from '@helu/core';
import { hydrateAppEnv } from './env/appEnv';

try {
  await hydrateAppEnv();
} catch (error) {
  console.error(
    'Failed to hydrate app environment; falling back to build-time configuration',
    error
  );
}

export const authManager = createAuthManager({
  realm: appEnv.AUTH_REALM,
  url: appEnv.AUTH_SERVER_URL,
  clientId: appEnv.AUTH_CLIENT_ID,
});
